import { render, staticRenderFns } from "./MonitorHome.vue?vue&type=template&id=28251c4e&scoped=true&"
import script from "./MonitorHome.vue?vue&type=script&lang=js&"
export * from "./MonitorHome.vue?vue&type=script&lang=js&"
import style0 from "./MonitorHome.vue?vue&type=style&index=0&id=28251c4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28251c4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VContainer,VMain})
